import { render, staticRenderFns } from "./device020-f-mianban.vue?vue&type=template&id=01e6a4e6&"
import script from "./device020-f-mianban.vue?vue&type=script&lang=js&"
export * from "./device020-f-mianban.vue?vue&type=script&lang=js&"
import style0 from "./device020-f-mianban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports